"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmptyState = void 0;
/*
 * © 2017 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const styled_components_1 = __importDefault(require("../styled-components"));
const __1 = require("..");
const EmptyState = ({ text, justify = "center" }) => {
    const { t, i18n } = (0, react_i18next_1.useTranslation)();
    /*
    This is necessary in order to get translations from one of several namespaces.
    We may need to look up the key in the Manatee, Helios or Jellyfish translation files.
    This function checks each loaded namespace for the key, and defaults to the Jellyfish "No Results" message if nothing is found.
    */
    const getTranslation = (key) => {
        var _a, _b;
        if (key) {
            const ns = (_b = (_a = i18n.reportNamespaces) === null || _a === void 0 ? void 0 : _a.getUsedNamespaces()) === null || _b === void 0 ? void 0 : _b.find((tns) => i18n.exists(key, { ns: tns }));
            if (ns) {
                return t(key, { ns });
            }
        }
        return t("message-No results");
    };
    return (react_1.default.createElement(Wrapper, { justify: justify },
        react_1.default.createElement(__1.Subtle, { noTitle: true }, getTranslation(text))));
};
exports.EmptyState = EmptyState;
const Wrapper = styled_components_1.default.div `
  width: 100%;
  height: 100%;
  display: flex;
  flex: 1 1 100%;
  justify-content: ${(props) => props.justify};
  align-items: center;
`;
//# sourceMappingURL=index.js.map